// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   IconButton,
// } from "@mui/material";
// import React, { useState } from "react";
// import { useForm, useFieldArray } from "react-hook-form";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField, {
//   TextType,
//   CurrencyType,
// } from "../../../Components/TextBox/WSTextBox";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";

// const PrescriptionBillCreate: React.FC = () => {
//   const {
//     control,
//     formState: { isValid },
//   } = useForm({
//     mode: "onChange",
//     defaultValues: {
//       customerName: "",
//       address: "",
//       email: "",
//       phone: "",
//       tax: "",
//       deliveryFee: "",
//       discount: "",
//       items: [{ productName: "", quantity: "", unitPrice: "" }],
//     },
//   });

//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "items",
//   });

//   return (
//     <form>
//       <Grid container spacing={2} mt={2}>
//         {/* ================= CUSTOMER DETAILS ================= */}
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
//             <Typography fontWeight="bold">Customer Details</Typography>

//             <Grid container spacing={2} mt={1}>
//               <Grid item xs={12}>
//                 <WSTextField
//                   id="customerName"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   name="customerName"
//                   label="Customer Name *"
//                   rules={{ required: true }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <WSTextField
//                   id="address"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   name="address"
//                   label="Address *"
//                   rules={{ required: true }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <WSTextField
//                   id="email"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   name="email"
//                   label="Email *"
//                   rules={{ required: true }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <WSTextField
//                   id="phone"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   name="phone"
//                   label="Phone Number *"
//                   rules={{ required: true }}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* ================= BILLING DETAILS ================= */}
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
//             <Typography fontWeight="bold">Billing Details</Typography>

//             <Grid container spacing={2} mt={1}>
//               <Grid item xs={12}>
//                 <WSTextField
//                   id="tax"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   type={TextType.Currency}
//                   currency={CurrencyType.Rupee}
//                   name="tax"
//                   label="Tax"
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <WSTextField
//                   id="deliveryFee"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   type={TextType.Currency}
//                   currency={CurrencyType.Rupee}
//                   name="deliveryFee"
//                   label="Delivery Fee"
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <WSTextField
//                   id="discount"  // ✅ ADDED REQUIRED ID
//                   control={control}
//                   type={TextType.Currency}
//                   currency={CurrencyType.Rupee}
//                   name="discount"
//                   label="Discount"
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* ================= PRESCRIPTION ITEMS ================= */}
//         <Grid item xs={12}>
//           <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
//             <Typography fontWeight="bold">Prescription Items</Typography>

//             {fields.map((item, index) => (
//               <Grid
//                 container
//                 spacing={2}
//                 alignItems="center"
//                 mt={1}
//                 key={item.id}
//               >
//                 <Grid item xs={12} sm={5}>
//                   <WSTextField
//                     id={`productName-${index}`}  // ✅ DYNAMIC ID
//                     control={control}
//                     name={`items.${index}.productName`}
//                     label="Product Name *"
//                     rules={{ required: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={3}>
//                   <WSTextField
//                     id={`quantity-${index}`}  // ✅ DYNAMIC ID
//                     control={control}
//                     type={TextType.Number}
//                     name={`items.${index}.quantity`}
//                     label="Quantity *"
//                     rules={{ required: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={3}>
//                   <WSTextField
//                     id={`unitPrice-${index}`}  // ✅ DYNAMIC ID
//                     control={control}
//                     type={TextType.Currency}
//                     currency={CurrencyType.Rupee}
//                     name={`items.${index}.unitPrice`}
//                     label="Unit Price *"
//                     rules={{ required: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={1}>
//                   <IconButton
//                     color="error"
//                     onClick={() => remove(index)}
//                     disabled={fields.length === 1}
//                   >
//                     <DeleteIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             ))}

//             <Box mt={2}>
//               <WSButton
//                 type="button"
//                 label="Add Item"
//                 startIcon={<AddIcon />}
//                 onClick={() =>
//                   append({
//                     productName: "",
//                     quantity: "",
//                     unitPrice: "",
//                   })
//                 }
//                 variant="outlined"
//                 id="addItem"  // ✅ FIXED WSButton id
//               />
//             </Box>
//           </Paper>
//         </Grid>

//         {/* ================= ACTION BUTTONS ================= */}
//         <Grid container justifyContent="flex-end" spacing={2} mt={2}>
//           <Grid item>
//             <WSButton
//               label="Cancel"
//               variant="outlined"
//               color="primary"
//               sx={{ width: "8rem" }}
//               id="cancelBtn"  // ✅ FIXED WSButton id
//             />
//           </Grid>

//           <Grid item>
//             <WSButton
//               label="Save"
//               variant="contained"
//               disabled={!isValid}
//               sx={{ width: "8rem" }}
//               id="saveBtn"  // ✅ FIXED WSButton id
//             />
//           </Grid>
//         </Grid>
//       </Grid>
//     </form>
//   );
// };

// export default PrescriptionBillCreate;








import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method,
} from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField, {
  TextType,
  CurrencyType,
} from "../../../Components/TextBox/WSTextBox";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

interface Product {
  id: string;
  productName: string;
  sellingPrice: number;
}

interface FormData {
  customerName: string;
  address: string;
  email: string;
  phoneNumber: string;
  tax: number;
  deliveryFee: number;
  discount: number;
  prescriptionOrderId: string; // 🔥 CHANGED: Backend expects this
  items: {
    ph_ProductId: string;
    quantity: number;
    unitPrice: number;
  }[];
}

const PrescriptionBillCreate: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [productsLoading, setProductsLoading] = useState<boolean>(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [orderId, setOrderId] = useState<string>("");
  const { showMessage } = useSnackbar();

  const {
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      customerName: "",
      address: "",
      email: "",
      phoneNumber: "",
      tax: 0,
      deliveryFee: 0,
      discount: 0,
      prescriptionOrderId: "", // 🔥 CHANGED field name
      items: [{ ph_ProductId: "", quantity: 1, unitPrice: 0 }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const formValues = useWatch({ control }) as FormData;

  // STEP 1: Set orderId FIRST
  useEffect(() => {
    console.log("🎯 STEP 1 - Setting orderId. ID:", id);
    const finalOrderId = id || "";
    setOrderId(finalOrderId);
    if (finalOrderId) {
      setValue("prescriptionOrderId", finalOrderId); // 🔥 EXACT backend field
    }
  }, [id, setValue]);

  // STEP 2: Fetch products
  useEffect(() => {
    let isCurrent = true;
    const fetchProducts = async () => {
      try {
        setProductsLoading(true);
        const response = await callAPI("pharmacy/products", Method.GET);
        const productsData = response?.data || response || [];
        if (Array.isArray(productsData) && isCurrent) {
          const simpleProducts: Product[] = productsData
            .filter((p: any) => p?.id && (p.isActive !== false) && !p?.isDeleted)
            .map((p: any) => ({
              id: p.id || p.productId || "",
              productName: p.productName || p.name || "Unnamed",
              sellingPrice: Number(p.sellingPrice) || Number(p.mrp) || 0
            }))
            .filter((p: Product) => p.id && p.productName);
          setProducts(simpleProducts);
        }
      } catch (error: any) {
        console.error("💥 PRODUCTS ERROR:", error);
        showMessage("Failed to load products", "error");
      } finally {
        if (isCurrent) setProductsLoading(false);
      }
    };
    fetchProducts();
    return () => { isCurrent = false; };
  }, [showMessage]);

  // STEP 3: Load order data
  useEffect(() => {
    if (!id || !orderId) {
      setLoading(false);
      return;
    }

    let isCurrent = true;
    const loadOrderData = async () => {
      try {
        setLoading(true);
        const response = await callAPI(`pharmacy/PrescriptionOrder/order-details/${id}`, Method.GET);
        const data = response?.data || response;
        if (data && isCurrent) {
          const formData = {
            customerName: data.patient?.username || "",
            address: data.patient?.address || "",
            phoneNumber: data.patient?.contactNumber || "",
            prescriptionOrderId: id, // 🔥 EXACT backend field
          };
          reset(formData);
        }
      } catch (error: any) {
        console.error("💥 ORDER ERROR:", error);
        showMessage("Failed to load order", "error");
      } finally {
        if (isCurrent) setLoading(false);
      }
    };
    loadOrderData();
    return () => { isCurrent = false; };
  }, [id, orderId, reset, showMessage]);

  const handleProductChange = (productId: string, index: number) => {
    const product = products.find(p => p.id === productId);
    if (product) {
      setValue(`items.${index}.unitPrice`, product.sellingPrice);
    }
  };

  // 🔥 PERFECT BACKEND MATCH + TechnicianDrawer pattern
  const saveBill = useCallback(async (data: FormData): Promise<any> => {
    const userId = getLocalValue(LoacalVariables.UserId) || "";
    
    // 🔥 FILTER VALID ITEMS ONLY (quantity > 0)
    const validItems = data.items
      .filter(item => item.ph_ProductId && Number(item.quantity) > 0)
      .map(item => ({
        // 🔥 Backend schema - NO prescriptionOrderInvoiceId needed for CREATE
        ph_ProductId: item.ph_ProductId,
        quantity: Number(item.quantity),
        unitPrice: Number(item.unitPrice) || 0
      }));

    if (validItems.length === 0) {
      throw new Error("Please add at least one product with quantity > 0");
    }

    // 🔥 EXACT BACKEND SCHEMA
    const requestBody = {
      customerName: data.customerName?.trim() || "",
      address: data.address?.trim() || "",
      email: data.email?.trim() || "",
      phoneNumber: data.phoneNumber?.trim() || "",
      tax: Number(data.tax) || 0,
      deliveryFee: Number(data.deliveryFee) || 0,
      discount: Number(data.discount) || 0,
      prescriptionOrderId: data.prescriptionOrderId || orderId || id!, // 🔥 EXACT field name
      items: validItems // 🔥 Backend expects this structure
    };

    console.log("📤 EXACT BACKEND PAYLOAD:", JSON.stringify(requestBody, null, 2));
    
    // 🔥 CORRECT API ENDPOINT
    const response: any = await callAPI("pharmacy/PrescriptionOrderInvoice", Method.POST, requestBody);
    console.log("✅ FULL RESPONSE:", response);
    return response;
  }, [orderId, id]);

  // 🔥 EXACT TechnicianDrawer handleSubmit pattern
  const handleSubmitData = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("🚀 FORM SUBMIT - TechnicianDrawer Pattern");
    
    if (saving) return;
    
    try {
      setSaving(true);
      
      // 🔥 Validate required fields
      if (!formValues.customerName?.trim()) {
        showMessage("Customer name is required", "error");
        return;
      }
      if (!formValues.address?.trim()) {
        showMessage("Address is required", "error");
        return;
      }
      if (!formValues.prescriptionOrderId) {
        showMessage("Order ID is required", "error");
        return;
      }
      
      const validItems = formValues.items?.filter(item => item.ph_ProductId && Number(item.quantity) > 0) || [];
      if (validItems.length === 0) {
        showMessage("Please add at least one product with quantity > 0", "error");
        return;
      }
      
      // 🔥 Call saveBill
      const response = await saveBill(formValues);
      
      console.log("✅ SUCCESS RESPONSE:", response);
      showMessage("✅ Bill created successfully!", "success");
      navigate(`/prescription-order-details/${id}`);
      
    } catch (error: any) {
      console.error("💥 ERROR:", error);
      const errorMsg = error?.message || error?.response?.data?.message || "Failed to save bill";
      showMessage(errorMsg, "error");
    } finally {
      setSaving(false);
    }
  };

  const handleCancelClick = () => navigate(`/prescription-order-details/${id}`);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
        <Typography ml={2}>Loading order details...</Typography>
      </Box>
    );
  }

  return (
    <>
      <WSButton
        id="backToOrder"
        label="← Back to Order"
        variant="outlined"
        onClick={handleCancelClick}
        color="success"
        sx={{ mb: 2,  borderRadius: 8,
      border: "1px solid #098963",     // Your pharmacy green
      color: "#098963",                // Text/icon green  
      backgroundColor: "#FFFFFF",      // White background (outlined style)
      "&:hover": {
        borderColor: "#066e4f",        // Darker green hover border
        color: "#066e4f",              // Darker green hover text
        backgroundColor: "#f0f8f0",    // Light green hover bg
      }, }}
        
      />
      
      <form id="prescription-bill-form" onSubmit={handleSubmitData}>
        <Grid container spacing={2} mt={2}>
          {/* Customer Details */}
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
              <Typography fontWeight="bold">Customer Details</Typography>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  <WSTextField
                    id="customerName-field"
                    control={control}
                    name="customerName"
                    label="Customer Name *"
                    rules={{ required: "Customer name is required" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    id="address-field"
                    control={control}
                    name="address"
                    label="Address *"
                    rules={{ required: "Address is required" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    id="email-field"
                    control={control}
                    name="email"
                    label="Email"
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    id="phoneNumber-field"
                    control={control}
                    name="phoneNumber"
                    label="Phone Number *"
                    rules={{
                      required: "Phone number is required",
                      pattern: { value: /^[0-9]{10}$/, message: "Enter valid 10-digit phone number" }
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Billing Details */}
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
              <Typography fontWeight="bold">Billing Details</Typography>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  <WSTextField
                    id="tax-field"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    name="tax"
                    label="Tax"
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    id="deliveryFee-field"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    name="deliveryFee"
                    label="Delivery Fee"
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    id="discount-field"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    name="discount"
                    label="Discount"
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Items */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
              <Typography fontWeight="bold">
                Items ({products.length} products available)
              </Typography>
              
              {productsLoading ? (
                <Box display="flex" justifyContent="center" p={4}>
                  <CircularProgress size={24} />
                  <Typography ml={2}>Loading products...</Typography>
                </Box>
              ) : products.length === 0 ? (
                <Typography color="error" sx={{ textAlign: 'center', p: 4 }}>
                  No products available
                </Typography>
              ) : (
                <>
                  {fields.map((item, index) => (
                    <Grid container spacing={2} alignItems="center" mt={2} key={item.id}>
                      <Grid item xs={12} sm={5}>
                        <Controller
                          name={`items.${index}.ph_ProductId`}
                          control={control}
                          rules={{ required: "Product is required" }}
                          render={({ field, fieldState: { error } }) => (
                            <FormControl fullWidth error={!!error} size="small">
                              <InputLabel>Product *</InputLabel>
                              <Select
                                {...field}
                                label="Product *"
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleProductChange(e.target.value as string, index);
                                }}
                                value={field.value || ""}
                              >
                                {products.map(product => (
                                  <MenuItem key={product.id} value={product.id}>
                                    {product.productName} (₹{product.sellingPrice})
                                  </MenuItem>
                                ))}
                              </Select>
                              {error && (
                                <Typography variant="caption" color="error">
                                  {error.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <WSTextField
                          id={`quantity-field-${index}`}
                          control={control}
                          type={TextType.Number}
                          name={`items.${index}.quantity`}
                          label="Quantity *"
                          rules={{ 
                            required: "Quantity is required", 
                            min: { value: 1, message: "Minimum 1" }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <WSTextField
                          id={`unitPrice-field-${index}`}
                          control={control}
                          type={TextType.Currency}
                          currency={CurrencyType.Rupee}
                          name={`items.${index}.unitPrice`}
                          label="Unit Price *"
                          rules={{ required: "Unit price is required" }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={1}>
                        <IconButton
                          color="error"
                          onClick={() => remove(index)}
                          disabled={fields.length === 1}
                          size="small"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                  <Box mt={3}>
  <WSButton
    id="addItemBtn"
    type="button"
    label="Add Item"
    startIcon={<AddIcon />}
    onClick={() => append({ ph_ProductId: "", quantity: 1, unitPrice: 0 })}
    variant="outlined"
    color="success"  // ✅ Uses MUI green theme color
    sx={{
      borderRadius: 8,
      border: "1px solid #098963",     // Your pharmacy green
      color: "#098963",                // Text/icon green  
      backgroundColor: "#FFFFFF",      // White background (outlined style)
      "&:hover": {
        borderColor: "#066e4f",        // Darker green hover border
        color: "#066e4f",              // Darker green hover text
        backgroundColor: "#f0f8f0",    // Light green hover bg
      },
    }}
  />
</Box>

                </>
              )}
            </Paper>
          </Grid>

          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 3 }}>
            <Grid item>
              <WSButton
                id="cancelBtn"
                type="button"
                label="Cancel"
                variant="outlined"
                onClick={handleCancelClick}
                 color="success"  // ✅ Uses MUI green theme color
    sx={{
      borderRadius: 8,
      border: "1px solid #098963",     // Your pharmacy green
      color: "#098963",                // Text/icon green  
      backgroundColor: "#FFFFFF",      // White background (outlined style)
      "&:hover": {
        borderColor: "#066e4f",        // Darker green hover border
        color: "#066e4f",              // Darker green hover text
        backgroundColor: "#f0f8f0",    // Light green hover bg
      },
    }}
              />
            </Grid>
            <Grid item>
              <WSButton
                id="saveBtn"
                type="submit"
                label={saving ? "Saving..." : "Save Bill"}
                variant="contained"
                loading={saving}
                disabled={saving || productsLoading || products.length === 0}
                 color="success"  // ✅ Uses MUI green theme color
    sx={{
      borderRadius: 8,
      border: "1px solid #098963",     // Your pharmacy green
      color: "#098963",                // Text/icon green  
      backgroundColor: "#FFFFFF",      // White background (outlined style)
      "&:hover": {
        borderColor: "#066e4f",        // Darker green hover border
        color: "#066e4f",              // Darker green hover text
        backgroundColor: "#f0f8f0",    // Light green hover bg
      },
    }}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default PrescriptionBillCreate;
